import * as React from "react";
import PropTypes from "prop-types";
import Sidebar from "./../Sidebar";
import { Main } from "./../Layout/elements";

import Header from "./../Header";

const ObjectLayout = ({ children, title }) => {
  return (
    <React.Fragment>
      <Header siteTitle={title || `Bob Stein Archives Timeline`} />
      <div>
        <Main>
          <Sidebar />
          <div>{children}</div>
        </Main>
        <footer></footer>
      </div>
    </React.Fragment>
  );
};

export default ObjectLayout;

ObjectLayout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};
